import { useEffect, useState } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faGraduationCap, faBars, faBookOpen, faSignOutAlt, faHouseUser, faCog, faUsers, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from "react-router";
import { useHistory } from "react-router";
import './EmpSidePanel.css';
import { Util } from '../../config/Util';

function EmpSidePanel({ collapsed, setCollapsed }) {

  const history = useHistory();
  const [isManager, setIsManager] = useState(false);
  const [isFacilitator, setIsFacilitator] = useState(false);
  const [isCILead, setIsCILead] = useState(false);
  const [ibtikarEnabled, setIbtikarEnabled] = useState(false);

  const readManagerFlag = () => {
    try {
      const userData = Util.getFromSession('userData') || {};
          const authData = Util.getFromSession('auth') || {};
      
      console.log('EmpSidePanel userData:', userData);
      const managerFlag = !!(userData?.managerView === true || (userData?.data && userData.data.managerView === true));
      const facilitatorFlag = !!(userData?.facilitator === true || (userData?.data && userData.data.facilitator === true));
      const ciLeadFlag = !!(userData?.cilead === true || (userData?.data && userData.data.cilead === true));
      const ibtikarFlag = authData?.ibtikarEnable;

      setIsManager(managerFlag);
      setIsFacilitator(facilitatorFlag);
      setIsCILead(ciLeadFlag);
      setIbtikarEnabled(ibtikarFlag);
    } catch (e) {
      setIsManager(false);
      setIsFacilitator(false);
      setIsCILead(false);
      setIbtikarEnabled(false);
    }
  };

  useEffect(() => {
    readManagerFlag();
    const handler = () => readManagerFlag();
    window.addEventListener('userDataUpdated', handler);
    return () => window.removeEventListener('userDataUpdated', handler);
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    history.push("/landing");
  };

  return (

    <div style={{ display: 'flex', height: '100%' }} className="admin-side-panel-wrapper">
      <Sidebar
        collapsed={collapsed}
        backgroundColor='rgba(29, 41, 61, 0.95)'
      >
        <button onClick={() => setCollapsed(!collapsed)} className="btn toggle-btn sb-button">
          <FontAwesomeIcon icon={faBars} />
        </button>
        <Menu>
          <MenuItem onClick={() => history.push("/user/home")} icon={<FontAwesomeIcon icon={faHouseUser} />}> Home</MenuItem>
          <MenuItem onClick={() => history.push("/user/communication")} icon={<FontAwesomeIcon icon={faBullhorn} />}> Communication</MenuItem>
          <MenuItem onClick={() => history.push("/user/assessment")} icon={<FontAwesomeIcon icon={faGraduationCap} />}> Assessment</MenuItem>
          <MenuItem onClick={() => history.push("/user/training")} icon={<FontAwesomeIcon icon={faBookOpen} />}> Training</MenuItem>
          {isManager && (
            <MenuItem onClick={() => history.push("/user/manager")} icon={<FontAwesomeIcon icon={faUsers} />}> My Team</MenuItem>
          )}

          <SubMenu icon={<FontAwesomeIcon icon={faCog} />} label="Settings">
            <MenuItem onClick={() => history.push("/user/settings")}> Change Password </MenuItem>
          </SubMenu>
          {ibtikarEnabled && (
          <SubMenu icon={<FontAwesomeIcon icon={faLightbulb} />} label="Ibtikar">
          {isCILead && (
            <MenuItem onClick={() => history.push("/user/ibtikar/leader-dashboard")}> Leader Dashboard </MenuItem>
          ) }
            {isFacilitator && (
              <MenuItem onClick={() => history.push("/user/ibtikar/facilitation")}> Facilitation </MenuItem>
            )}
            <MenuItem onClick={() => history.push("/user/ibtikar/submissions")}> Submissions </MenuItem>
            <MenuItem onClick={() => history.push("/user/ibtikar/implementation")}> Implementation </MenuItem>
          </SubMenu>
        )}
          <MenuItem onClick={handleLogout} icon={<FontAwesomeIcon icon={faSignOutAlt} />}> Logout</MenuItem>
        </Menu>
      </Sidebar>

    </div>
  );
}

export default withRouter(EmpSidePanel);